import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  marginTop: "10px",
  borderRadius: "8px",
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  background: "linear-gradient(90deg, #00BB9F 0%, #6CD8BF 100%)",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  color: "#FFFFFF", // Set text color to white for header cells
}));

const BodyTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
}));

const ProductTable = ({ title, headers, rows, className }) => {
  console.log(headers);

  // State for modal open
  return (
    <div className={className}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <StyledTableContainer component={Paper}>
        <Table>
          <StyledTableHead>
            <TableRow>
              {headers.map((item, key) => (
                <StyledTableCell key={key}>{item.label}</StyledTableCell>
              ))}
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, index) => (
                <TableRow key={index}>
                  {Object.values(row).map((value, idx) =>
                    value == "ใกล้หมดอายุ" ? (
                      <BodyTableCell key={idx}>
                        <Chip
                          label={value}
                          style={{
                            width: "100px",
                            backgroundColor: "#F18807",
                            color: "white",
                          }}
                        />
                      </BodyTableCell>
                    ) : (
                      <BodyTableCell key={idx}>{value}</BodyTableCell>
                    )
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <BodyTableCell colSpan={8} style={{ textAlign: "center" }}>
                  ไม่มีข้อมูล
                </BodyTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </div>
  );
};

export default ProductTable;
